import { useQueryClient } from "@trueskin-web/apis"
import { useAuth } from "@trueskin-web/context"
import { Trans } from "@trueskin-web/translations"

import Card from "./card"
import Checkout from "./checkout"
import ChoosePlan from "./choose-plan"
import Diagnosis from "./diagnosis"
import PhotoUpload from "./photo-upload"
import SkinAnalysis from "./skin-analysis"
import UVPs from "./uvps"

const Steps = () => {
  const queryClient = useQueryClient()
  const { user } = useAuth()

  const { data } = queryClient.getQueryData("currentOrderSummary")
  const { billingAddresses: [billingAddress] = [] } = user || {}

  const canAccessCheckout = data?.lineItems?.length > 0 && !!billingAddress

  return (
    <div
      sx={{
        mb: "89px",
        overflow: "hidden",
      }}
    >
      <SkinAnalysis />

      {canAccessCheckout ? (
        <>
          <UVPs />
          <Checkout />
        </>
      ) : (
        <>
          <ChoosePlan />
          <Card dataTestId="wb-steps-proceed-to-payment">
            <Trans i18nKey="Start.WelcomeBack.Steps.proceedToPayment" />
          </Card>
        </>
      )}

      <PhotoUpload />

      <Diagnosis />
    </div>
  )
}

export default Steps
